import LastSessionUser from './LastSessionUser'

export default LastSessionUser
